import { getQaSelector } from '../../utils/common'
import { FormikForm } from '../Formik'

import { QA_NAME_AI_TEXT_GENERATION } from './AITextGeneration.constants'
import { useAITextGenerationState } from './AITextGeneration.hooks'
import { AITextGenerationFormFields } from './AITextGenerationFormFields'

import * as styles from './AITextGeneration.module.css'

function AITextGeneration({
  className = styles.AITextGeneration,
  disabled,
  fieldContent,
  isLoading,
  localContext,
  regenerateRef,
  type,
  onGenerate,
  onGenerateStart,
  onGenerateStop,
}) {
  const {
    errorMessage,
    hasGeneratedOnce,
    initialValues,
    isGenerating,
    isTemplatesLoading,
    lastSubmittedSettings,
    lengthOptions,
    templates,
    toneOptions,
    onSubmit,
  } = useAITextGenerationState({
    fieldContent,
    localContext,
    type,
    onGenerate,
    onGenerateStart,
    onGenerateStop,
  })

  const qaProps = getQaSelector({
    value: QA_NAME_AI_TEXT_GENERATION,
  })

  return (
    <div {...qaProps} className={className}>
      <FormikForm
        Component='div'
        initialValues={initialValues}
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={onSubmit}
      >
        <AITextGenerationFormFields
          disabled={disabled}
          errorMessage={errorMessage}
          hasFieldContent={Boolean(fieldContent)}
          hasGeneratedOnce={hasGeneratedOnce}
          isGenerating={isGenerating}
          isTemplatesLoading={isLoading || isTemplatesLoading}
          lastSubmittedSettings={lastSubmittedSettings}
          lengthOptions={lengthOptions}
          regenerateRef={regenerateRef}
          templates={templates}
          toneOptions={toneOptions}
        />
      </FormikForm>
    </div>
  )
}

export default AITextGeneration
